/* Native overflow scrolling; no slider dependency and no wheel interception. */
if (!customElements.get('dmg-carousel')) {
  customElements.define('dmg-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.controls = this.querySelector('[data-controls]');
      if (!this.track || !this.controls) return;
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.status = this.querySelector('[data-status]');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.prev.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.track.scrollTo({ left: event.key === 'Home' ? 0 : this.track.scrollWidth, behavior: 'auto' });
        }
      }, options);
      if (window.ResizeObserver) {
        this.resize = new ResizeObserver(() => this.update());
        this.resize.observe(this.track);
      } else {
        window.addEventListener('resize', () => this.update(), options);
      }
      this.update();
    }
    disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
    move(direction) {
      this.track.scrollBy({ left: direction * this.track.clientWidth * .82,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.controls.hidden = max < 3;
      this.prev.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= max - 2;
      if (this.status) {
        const cards = [...this.track.children];
        const left = this.track.getBoundingClientRect().left;
        const first = Math.max(0, cards.findIndex((card) => card.getBoundingClientRect().right > left + 4));
        const visible = cards.filter((card) => {
          const box = card.getBoundingClientRect();
          return box.right > left + 4 && box.left < left + this.track.clientWidth - 4;
        }).length;
        const message = `${first + 1}–${Math.min(cards.length, first + visible)} of ${cards.length}`;
        if (this.status.textContent !== message) this.status.textContent = message;
      }
    }
  });
}

document.addEventListener('click', (event) => {
  const link = event.target.closest('.dmg-product-use a[data-product-options]');
  if (!link) return;
  const target = document.querySelector('[id^="ProductInfo-"]');
  if (!target) return;
  event.preventDefault();
  target.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  const control = target.querySelector('variant-selects input, variant-selects select, .product-form__submit');
  control?.focus({ preventScroll: true });
});

// Browser history can restore cached markup; request Shopify's current session state again.
window.addEventListener('pageshow', (event) => {
  if (event.persisted) window.location.reload();
});
